<template>
  <div class="task-items-outer">
    <div class="task-list">
      <div
        v-for="task in tasks"
        :key="task._id"
        :class="computeTaskItemClass(task)"
        @click="onTaskClick(task)"
      >
        <div
          class="select-checkbox"
          v-if="task.taskType !== 'folder' && selectMode"
        >
          <b-checkbox size="is-medium" :value="isSelected(task)"></b-checkbox>
        </div>
        <div class="thumbnail">
          <div v-if="task.taskType !== 'folder'" class="task-img-icon">
            <img class="img-icon" :src="getTaskIcon(task)" />
          </div>

          <img
            v-if="task.taskType !== 'folder'"
            class="task-img"
            :src="getTaskThumbnail(task)"
          />
        </div>

        <div :class="completenessClass(task)">
          <div class="note-inner">
            <div class="note-inner-task-name">
              {{ task.taskName }}
            </div>

            <div class="diagram-icons" v-if="task.taskType === 'diagram'">
              <div
                v-for="icon in task.measurementsTypes || []"
                :key="icon"
                :class="'icon-img icon-' + icon"
                :title="icon.charAt(0).toUpperCase() + icon.slice(1)"
              ></div>

              <b-tag rounded style="margin-left: auto">
                <span v-if="isTaskCompleted(task)">
                  <b-icon icon="check" type="is-success"></b-icon>
                </span>
                <span v-else>
                  {{ parseFloat(task.completenessPercentage || 0).toFixed(2) }}
                  %
                </span>
              </b-tag>
            </div>

            <b-tag
              v-if="task.taskType !== 'diagram'"
              rounded
              style="margin-left: auto"
            >
              <span v-if="isTaskCompleted(task)">
                <b-icon icon="check" type="is-success"></b-icon>
              </span>
              <span v-else>
                {{ parseFloat(task.completenessPercentage || 0).toFixed(2) }} %
              </span>
            </b-tag>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TasksDisplayGrid',

  props: {
    tasks: {
      type: Array,
      default: () => [],
    },

    selectMode: {
      type: Boolean,
      default: false,
    },

    preSelectedTasks: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      selectedTasks: [],
    };
  },

  mounted() {
    this.selectedTasks = [...this.preSelectedTasks];
  },

  methods: {
    onTaskClick(task) {
      if (this.selectMode && task.taskType !== 'folder') {
        this.onTaskSelect(task);
      } else {
        this.$emit('task-click', task);
      }
    },

    onTaskSelect(task) {
      const index = this.selectedTasks.findIndex((t) => task._id === t._id);
      if (index > -1) {
        this.selectedTasks.splice(index, 1);
      } else {
        this.selectedTasks.push(task);
      }
    },

    computeTaskItemClass(task) {
      let classes = 'task-item';

      if (task.taskType === 'folder') {
        classes += ' folder folder-clip-path';
      }
      return classes;
    },

    isTaskCompleted(task) {
      return task.workStatusCode
        ? task.workStatusCode.toString() === '2'
        : false;
    },

    completenessClass(task) {
      if (this.isTaskCompleted(task)) {
        return 'note-complete';
      }

      if (parseFloat(task.completenessPercentage || 0) > 0) {
        return 'note-medium';
      }

      return 'note-begin';
    },

    getTaskIcon(task) {
      if (task.taskType === 'diagram') {
        return '/img/diagram_icon.png';
      }

      if (task.taskType === 'instruction') {
        return '/img/Instruction_icon.png';
      }

      return '';
    },

    isSelected(task) {
      const index = this.selectedTasks.findIndex((t) => {
        return task._id === t._id;
      });
      if (index > -1) return true;
      return false;
    },

    getTaskThumbnail(task) {
      if (!task || typeof task !== 'object') {
        return '/img/image-empty.png';
      }

      if (task.taskType === 'diagram') {
        if (task.diagram?.src && typeof task.diagram.src === 'string') {
          const parts = task.diagram.src.split('/');
          const lastPart = parts.pop();
          const allButLast = parts.join('/');
          const imageSource = `${allButLast}/${encodeURIComponent(lastPart)}`;

          return window.location.host.includes('localhost')
            ? `http://localhost:4566/images${imageSource}`
            : imageSource;
        }

        return '/img/image-empty.png';
      }

      if (task.taskType === 'instruction') {
        if (task.thumbnailUrl) {
          return window.location.host.includes('localhost')
            ? `http://localhost:4566/images${task.thumbnailUrl}`
            : task.thumbnailUrl;
        }

        return '/img/ic-assignment-black-24-px.png';
      }

      if (task.taskType === 'folder') {
        return '';
      }

      return '/img/image-empty.png';
    },
  },
};
</script>

<style scoped lang="scss">
.task-items-outer {
  height: 100% !important;
}

.task-list {
  display: flex;
  flex-wrap: wrap;
  padding: 10px 30px;
  height: 100% !important;
}

.task-item {
  position: relative;
}

.task-items-outer .task-item {
  display: block;
  width: 200px;
  height: 220px;
  margin: 0px 8px 30px 4px;
  color: #333;
  font-family: 'Siemens Sans';

  .thumbnail {
    width: 100%;
    height: 150px;
  }
}

.thumbnail {
  position: relative;
  width: 100%;
  height: 150px;
  display: flex;
}

.task-img {
  width: auto;
  max-height: 100%;
  max-width: 100%;
  margin: auto;
}

.task-img-icon {
  position: absolute;
  top: 5%;
  left: 80%;
}

.img-icon {
  width: auto;
  max-height: 100%;
  max-width: 100%;
}

.folder {
  background-color: #afafaf;
  color: #222;
}

.folder-clip-path {
  clip-path: polygon(0 0, 30% 0, 34% 10%, 100% 10%, 200% 110%, -100% 110%);
}

.note-inner {
  display: inline-flex;
  flex-direction: column;
}

.note-begin,
.note-medium,
.note-complete {
  .note-inner {
    .note-inner-task-name {
      max-width: 100%;
      max-height: none;
      white-space: normal;
      text-align: left;
    }
  }
}

.note-inner-task-name {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}

.diagram-icons {
  display: flex;
  align-items: center;
  min-height: 25px;
}

.icon-img {
  min-height: 20px;
}

.task-disabled {
  position: relative;
}

.task-disabled::after {
  content: '';
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  border: 1px dashed rgba(150, 150, 150, 0.5);
  z-index: 10;
  pointer-events: auto;
  cursor: not-allowed;
}

.select-checkbox {
  position: absolute;
  top: 6px;
  left: 6px;
  z-index: 30;
  padding: 2px;
  pointer-events: none;
}
</style>
